import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import { INROUTES } from './../common/links';
import IcSkytone from './../assets/icon/skytone-frame.svg';
import IcLogo from './../assets/icon/bi-dafthings.svg';
import Footer from './../components/Footer';
import 'swiper/css';
import 'swiper/css/pagination'; // Pagination 스타일
import { Pagination } from 'swiper/modules';

const Home = ({ handleMenu }) => {
    const [menuOpened, setMenuState] = useState(false);
    const [appThemeColor, setThemeColor] = useState('dark');
    const changeMenuState = () => {
        setMenuState(!menuOpened)
    }
    const changeThemeColor = (swiper) => {
        let currentSlide = swiper.slides[swiper.activeIndex];
        setThemeColor(currentSlide.dataset.theme);
    }
    useEffect(() => {
        setMenuState(false);
        setThemeColor('dark');
        // iframe의 player를 초기화
        const player = document.querySelector('.video-player');
        
        // YouTube API 로드
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // YouTube Player API 준비
        window.onYouTubeIframeAPIReady = () => {
            new window.YT.Player(player, {
                events: {
                    onReady: (event) => {
                        // 플레이어가 준비되면 품질을 최고로 설정
                        event.target.setPlaybackQuality('hd1080');
                    },
                    onStateChange: (event) => {
                        if (event.data === window.YT.PlayerState.PLAYING) {
                            let isChecking = false;
                            
                            // 0.1초마다 체크 (더 자주 체크)
                            const checkTime = setInterval(() => {
                                if (isChecking) return;
                                
                                isChecking = true;
                                const currentTime = event.target.getCurrentTime();
                                const duration = event.target.getDuration();
                                
                                // 영상 끝나기 2초 전에
                                if (duration - currentTime <= 2) {
                                    event.target.seekTo(0.1); // 약간의 오프셋을 줌
                                    event.target.playVideo();
                                }
                                
                                isChecking = false;
                            }, 100);

                            // 메모리 누수 방지
                            return () => clearInterval(checkTime);
                        }
                    }
                },
                playerVars: {
                    autoplay: 1,
                    controls: 0,
                    disablekb: 1,
                    loop: 1,
                    modestbranding: 1,
                    playsinline: 1,
                    rel: 0,
                    showinfo: 0,
                    mute: 1,
                    start: 1,
                    vq: 'hd1080'
                }
            });
        }; 
    }, []);

    return (
        <>
            <div id="app" className={menuOpened ? 'things nav-opened' : 'things'} data-theme={appThemeColor}>       
                <nav id="nav">
                    <ul className="menu wrap">
                        <li><Link to={INROUTES.SKYTONE} name="page" value="About"><span className="icon"><img src={IcSkytone} alt="SKYTONE" className="svg"/></span><span className="name"><small>PROJECT III</small><em>SKYTONE</em></span></Link></li>
                        <li><button type="button" name="page" disabled><span className="icon"></span><span className="name"><small>PROJECT II</small><em>INSTA FOLLOWER</em></span></button></li>
                        <li><button type="button" name="page" disabled><span className="icon"></span><span className="name"><small>PROJECT I</small><em>YOUTUBE COUNTER</em></span></button></li>
                    </ul>
                    <Footer />
                </nav>         
                <header id="header">
                    <div className="wrap flx">
                        <Link to={INROUTES.HOME} className="bi" name="page">
                            <button type="button">
                                <span className="icon">
                                    <img src={IcLogo} alt="Dafthings Logo" className="svg"/>
                                </span>
                            </button>
                        </Link>
                        <h1 className="bname">
                            DAFTHINGS
                        </h1>
                        <button type="button" className="nav" onClick={changeMenuState}><span className="icon"><i className="bar"></i></span></button>
                    </div>
                </header>
                <section id="container">
                    <div className="full-background">
                        <Swiper
                                direction="vertical" // 수직 방향 설정
                                slidesPerView={1} // 한 번에 보여줄 슬라이드 수
                                spaceBetween={0} // 슬라이드 간격
                                modules={[Pagination]} // 사용 모듈 설정
                                pagination={{ clickable: true, type:'bullets' }} // 페이지네이션 활성화
                                onInit={changeThemeColor} // 초기화 이벤트
                                onSlideChange={changeThemeColor} // 슬라이드 변경 이벤트
                            >
                            <SwiperSlide data-title="skytone" data-theme="dark">
                                <div className="swiper-background wide">
                                    <iframe
                                    src="https://www.youtube.com/embed/Wimkqo8gDZ0?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1&playlist=Wimkqo8gDZ0&playsinline=1&start=1&hd=1&vq=hd1080&modestbranding=1&enablejsapi=1"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen className="video-player">                                      
                                    </iframe>
                                    <span className="backdrop-layer"></span>
                                </div>
                                <Link to={INROUTES.SKYTONE} className="swiper-contents">
                                    <span className="project-icon"><img src={IcSkytone}  alt="Skytone Frame" className="svg" /></span>
                                    <p className="project-no">PROJECT III</p>
                                    <p className="project-name">SKYTONE</p>
                                    <div className="project-desc">
                                        <p>오늘의 공기는 어떤 색일까요?</p>
                                        <p>하늘을 닮은 작은 액자, SKYTONE</p>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    <Footer />
                </section>
            </div>
        </>
    );
};

export default Home;